import { escapeHtml } from '../core/utils.js';

/* Menú desplegable anclado a un botón (⋯ de la ficha). items: [{ icon, label, onClick }]. */

let seq = 0;

export function openMenu(target, items, { cssClass = '' } = {}) {
    const app = window.app;
    const list = items.filter(Boolean);
    if (!app || !list.length) return null;
    const id = 'menu-' + (++seq);
    const popover = app.popover.create({
        targetEl: target,
        arrow: false,
        content: `<div class="popover user-menu drop-menu ${cssClass}" id="${id}"><div class="popover-inner">${list.map((it, i) => `<button type="button" class="user-menu-item" data-menu-item="${i}" ${i === 0 ? 'data-nav-default' : ''}><span class="mi">${it.icon}</span><span>${escapeHtml(it.label)}</span></button>`).join('')}</div></div>`,
        on: {
            open(p) {
                p.$el[0].addEventListener('click', (e) => {
                    const btn = e.target.closest('[data-menu-item]');
                    if (!btn) return;
                    e.preventDefault();
                    e.stopPropagation();
                    const item = list[Number(btn.getAttribute('data-menu-item'))];
                    popover.close();
                    if (item && item.onClick) item.onClick();
                });
            },
            closed() {
                try { popover.destroy(); } catch (e) { /* ignore */ }
                const el = document.getElementById(id);
                if (el && el.parentNode) el.parentNode.removeChild(el);
            }
        }
    });
    popover.open();
    return popover;
}
